import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { TreeNode } from "primeng/api";
import { AccountService } from "../service/account.service";

@Component({
    selector: "modal-show-line-accounts",
    templateUrl: "./modal-show-line-accounts.component.html",
})
export class ModalShowLineAccounts implements OnInit {
    constructor(private accountService: AccountService) {
        this.tableColumns = [
            { field: "name", header: "Name", width: "70%" },
            { field: "lineNumbers", header: "Row #", width: "30%" },
        ];
    }

    @Input() lineId: number;
    @Input() filter: string = null;

    @Input() buttonIcon: string = null;
    @Input() buttonText: string = null;

    @Output() onClose = new EventEmitter<boolean>();

    displayTable: boolean = false;
    accountsForTableExist: boolean;
    accountsForTable: TreeNode[];
    tableColumns: any[];
    loading: boolean = false;
    modalText: string;
    error: string = null;

    ngOnInit() {
       this.fillAccounts();
    }
    fillAccounts() {
        if (this.lineId) {
            this.loading = true;
            if (!this.buttonIcon && !this.buttonText) {
                this.displayTable = true;
            }
            if (this.filter == "included") {
                this.modalText = "Included Accounts";
                this.accountService
                    .getForLine(this.lineId.toString())
                    .then((accounts) => this.loadAccounts(accounts));
            } else if (this.filter == "excluded") {
                this.modalText = "Excluded Accounts";
                this.tableColumns = [
                    { field: "name", header: "Name", width: "100%" },
                ];
                this.accountService
                    .getExcludedForLine(this.lineId.toString())
                    .then((accounts) => this.loadAccounts(accounts));
            } else {
                this.modalText = "Error";
                this.error = "Error has occured: no filter was specified.";
                this.loading = false;
            }
        }
    }

    loadAccounts(accounts: TreeNode[]) {
        this.accountsForTable = accounts;
        this.accountsForTableExist =
            this.accountsForTable && this.accountsForTable.length > 0
                ? true
                : false;
        this.loading = false;
    }

    closed() {
        this.onClose.emit(true);
    }

    onShow() {
        this.fillAccounts()
    }
}
